import {
  GET_CONSUMPTION_FAILURE,
  GET_CONSUMPTION_REQUEST,
  GET_CONSUMPTION_SUCCESS,
  DOWNLOAD_CONSUMPTION_REQUEST,
  DOWNLOAD_CONSUMPTION_SUCCESS,
  DOWNLOAD_CONSUMPTION_FAILURE,
} from "./consumptionTypes";

const initialStateForConsumptionReport = {
  loading: false,
  consumptionReport: [],
  error: "",
};

const getConsumptionReportReducer = (
  state = initialStateForConsumptionReport,
  action
) => {
  switch (action.type) {
    case GET_CONSUMPTION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CONSUMPTION_SUCCESS:
      return {
        loading: false,
        consumptionReport: action.payload,
        error: "",
      };
    case GET_CONSUMPTION_FAILURE:
      return {
        loading: false,
        consumptionReport: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForDownloadConsumptionReport = {
  loading: false,
  consumptionReport: [],
  error: "",
};

const downloadConsumptionReportReducer = (
  state = initialStateForDownloadConsumptionReport,
  action
) => {
  switch (action.type) {
    case DOWNLOAD_CONSUMPTION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DOWNLOAD_CONSUMPTION_SUCCESS:
      return {
        loading: false,
        consumptionReport: action.payload,
        error: "",
      };
    case DOWNLOAD_CONSUMPTION_FAILURE:
      return {
        loading: false,
        consumptionReport: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getConsumptionReportReducer, downloadConsumptionReportReducer };
